export default {
  "home.heading.default": "vào call thôi",
  "home.heading.loading": "Đang mở phòng...",
  "home.heading.join": "sẵn sàng vô chưa?",
  "home.heading.joined": "vô rồi nè",
  "home.heading.pending": "đang đợi host",
  "home.body.default": "tạo phòng, quăng link, chill thôi.",
  "home.body.loading": "chờ xíu, đang chuẩn bị phòng.",
  "home.body.join": "check cam với mic rồi nhảy vô luôn.",
  "home.body.joined": "phòng mở rồi. share link hoặc vô luôn.",
  "home.body.joined_in_room": "đang trong phòng — nhảy vô hoặc share link.",
  "home.body.pending": "phòng đang khóa. đợi host duyệt nha.",
  "home.cta.create": "Tạo phòng",
  "home.cta.join": "Vào phòng",
  "home.cta.enter": "Vô phòng",
  "home.cta.creating": "Đang tạo...",
  "home.cta.joining": "Đang vào...",
  "home.cta.opening": "Đang mở...",
  "home.cta.pending": "Đang chờ duyệt...",
  "home.copy_link": "copy link",
  "home.copied": "đã copy!",
  "home.leave": "rời phòng",
  "home.back": "quay lại",
  "home.no_participants": "chưa có ai ở đây",
  "home.join_by_code": "vào bằng mã mời",
  "home.code_placeholder": "nhập mã",
  "home.name_placeholder": "tên bạn",
  "home.people_one": "người",
  "home.people_other": "người",
  "home.marketing.invite.title": "Tạo phòng,\nshare link.",
  "home.marketing.invite.body": "Chạm là bắt đầu. Gửi link cho bạn bè và ai cũng vô được — không cần tải, khỏi cần đăng ký.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Lên hình\nnhư ý.",
  "home.marketing.look.body": "Chỉnh màu, làm mịn, tối góc — hoặc làm mờ mặt luôn cũng được. Cam của bạn, style của bạn.",
  "home.marketing.host.title": "Sân chơi của bạn,\nluật của bạn.",
  "home.marketing.host.body": "Khóa phòng, tắt mic ai đó, hoặc kick luôn. Host nắm toàn quyền.",
  "home.marketing.host.locked": "Phòng đã khóa",
  "home.marketing.host.waiting_to_join": "Đang chờ vào",
  "home.marketing.host.wants_to_join": "muốn vào phòng",
  "home.marketing.anything.title": "Làm gì cũng hợp.",
  "home.marketing.anything.body": "Học nhóm, cày game, họp hành, xem phim chung — hay đơn giản là ngồi chill.",
  "home.marketing.use_case.study_group": "📚 học nhóm",
  "home.marketing.use_case.game_night": "🎮 cày game",
  "home.marketing.use_case.standup": "💼 họp nhanh",
  "home.marketing.use_case.watch_party": "🍿 xem chung",
  "home.marketing.use_case.catch_up": "☕ tám chuyện",
  "home.marketing.use_case.jam_session": "🎸 chơi nhạc",
  "home.marketing.use_case.book_club": "📖 hội đọc sách",
  "home.marketing.use_case.coworking": "💻 làm việc chung",
  "ended.heading": "cuộc gọi kết thúc",
  "ended.left": "bạn đã rời phòng.",
  "ended.room_ended": "{title} đã kết thúc với bạn.",
  "ended.rejoin": "vào lại",
  "ended.rejoining": "đang vào lại...",
  "ended.home": "về trang chủ",
  "call.connecting": "đang kết nối",
  "call.waiting": "đang đợi mọi người",
  "call.invite_code": "mã mời",
  "call.audio_on": "đang bật âm thanh",
  "call.muted": "đã tắt mic",
  "call.listening": "Đang nghe",
  "call.audio_muted": "Đã tắt âm",
  "call.speaking": "đang nói",
  "call.you": "bạn",
  "call.you_label": "Bạn",
  "call.you_suffix": "(bạn)",
  "call.chat_placeholder": "nhắn gì đi...",
  "call.guest": "khách",
  "call.room_fallback": "phòng",
  "call.focus_view": "Chế độ tập trung",
  "call.grid_view": "Chế độ lưới",
  "call.swap_main_video": "Đổi video chính",
  "call.open_chat": "Mở chat",
  "call.close_chat": "Đóng chat",
  "call.leave_room": "Rời phòng",
  "call.confirm_leave": "Rời đi?",
  "call.mic_on": "Đang bật mic",
  "call.muted_label": "Đã tắt mic",
  "call.camera_off": "Đã tắt cam",
  "call.connect_failed": "Lỗi kết nối — check lại mạng rồi thử lại nha.",
  "call.camera_access_failed": "Không mở được cam. Check lại quyền trên trình duyệt rồi thử lại nha.",
  "call.recording_failed": "Không thể bắt đầu ghi hình. Cuộc gọi vẫn sẽ tiếp tục.",
  "call.initialize_failed": "Có lỗi khi bắt đầu cuộc gọi. F5 lại trang nha.",
  "call.participants": "Người tham gia",
  "call.open_participants": "Mở danh sách",
  "call.close_participants": "Đóng danh sách",
  "call.lock_room": "Khóa phòng",
  "call.unlock_room": "Mở khóa phòng",
  "call.locked": "đã khóa",
  "call.unlocked": "đang mở",
  "call.kick_member": "Kick khỏi phòng",
  "call.mute_member": "Tắt mic",
  "call.unmute_member": "Mở mic",
  "call.muted_by_host": "Bị host tắt mic",
  "call.waiting_to_join": "Đang chờ vào",
  "call.approve": "Duyệt",
  "call.deny": "Từ chối",
  "call.profile_actions": "Tùy chọn profile",
  "call.profile_in_room": "Trong phòng",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Bạn",
  "call.profile_action_mute": "Tắt âm người này",
  "call.profile_action_mute_meta": "Chỉ mình bạn nghe — họ sẽ không biết đâu",
  "call.profile_action_dm": "Nhắn tin riêng",
  "call.profile_action_dm_meta": "Mở chat riêng tư",
  "call.profile_action_view": "Xem full profile",
  "call.profile_action_view_meta": "Bio, ngôn ngữ, các phiên trước",
  "call.profile_action_report": "Báo cáo",
  "call.profile_action_report_meta": "Đánh dấu để admin xem xét",
  "call.profile_sheet_close": "Đóng tùy chọn",
  "call.profile_open_actions": "Mở tùy chọn",
  "call.dm_title": "Tin nhắn riêng",
  "call.dm_back": "Quay lại",
  "call.dm_close": "Đóng tin nhắn",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "Đang trong phòng",
  "call.dm_private_label": "Chat riêng",
  "call.dm_private_meta": "Chỉ hai người mới thấy tin nhắn này",
  "call.dm_input_placeholder": "Nhắn tin riêng…",
  "call.dm_send": "Gửi",
  "call.dm_just_now": "vừa xong",
  "call.dm_seen_just_now": "Vừa xem",
  "call.dm_typing": "{name} đang gõ…",
  "call.dm_minimize": "Thu nhỏ",
  "call.dm_active_indicator": "Mở cuộc trò chuyện",
  "call.dm_unread_messages": "{count} tin chưa đọc",
  "call.dm_toast_tap_to_open": "Chạm để mở",
  "call.dm_reopen_aria": "Mở lại chat với {name}",
  "home.join_denied": "Host không cho bạn vô.",
  "home.error.room_not_found": "Mã phòng này không tồn tại.",
  "home.error.profile_required": "Cài đặt profile để tiếp tục nha.",
  "home.cta.set_up_profile": "Cài đặt profile",
  "home.profile_trigger_new": "Chạm để thêm thông tin",
  "home.profile_trigger_new_aria": "Cài đặt profile",
  "home.profile_trigger_edit_aria": "Sửa profile",
  "profile.eyebrow_new": "say hi",
  "profile.eyebrow_edit": "profile của bạn",
  "profile.title_new": "Tạo nét riêng.",
  "profile.title_edit": "Sửa profile",
  "profile.subtitle": "Vài thông tin cơ bản để mọi người biết bạn là ai nè.",
  "profile.add_photo": "Thêm ảnh",
  "profile.add_photo_soon": "sắp có tính năng ảnh",
  "profile.photo_empty": "chạm để thêm ảnh",
  "profile.photo_ready": "ảnh đã sẵn sàng",
  "profile.photo_save_first": "lưu profile trước khi tải ảnh lên nha",
  "profile.photo_crop_caption": "căn chỉnh ảnh",
  "profile.photo_auto_caption": "kéo và zoom, hệ thống sẽ tự lưu",
  "profile.photo_upload": "Tải ảnh lên",
  "profile.photo_replace": "Đổi ảnh",
  "profile.photo_remove": "Xóa ảnh",
  "profile.photo_cancel": "Hủy",
  "profile.photo_save": "Lưu ảnh",
  "profile.photo_uploading": "Đang tải ảnh…",
  "profile.photo_removing": "Đang xóa ảnh…",
  "profile.photo_choose_another": "Chọn ảnh khác",
  "profile.photo_drag_hint": "Kéo ảnh vào trong vòng tròn. Sẽ tự động lưu nha.",
  "profile.photo_zoom": "Phóng to",
  "profile.photo_horizontal": "Cắt ngang",
  "profile.photo_vertical": "Cắt dọc",
  "profile.name_label": "Tên",
  "profile.name_placeholder": "Mọi người nên gọi bạn là gì?",
  "profile.gender_label": "Giới tính",
  "profile.gender.woman": "Nữ",
  "profile.gender.man": "Nam",
  "profile.gender.unspecified": "Không muốn tiết lộ",
  "profile.bio_label": "Giới thiệu",
  "profile.bio_optional": "không bắt buộc",
  "profile.bio_placeholder": "Ngôn ngữ bạn biết, sở thích, hay bất cứ thứ gì…",
  "profile.cta_new": "Lên luôn",
  "profile.cta_edit": "Lưu thay đổi",
  "profile.saving": "Đang lưu…",
  "profile.close": "Đóng",
  "profile.error.save_failed": "Không lưu được profile. Thử lại nha.",
  "profile.error.avatar_invalid_type": "Chọn ảnh định dạng PNG, JPEG, GIF, hoặc WebP nha.",
  "profile.error.avatar_too_large": "Chọn ảnh nhỏ hơn 5MB thôi.",
  "profile.error.avatar_too_small": "Chọn ảnh ít nhất là 96x96 pixel nha.",
  "profile.error.avatar_load_failed": "Không đọc được ảnh này. Thử file khác xem.",
  "profile.error.avatar_failed": "Không tải ảnh lên được. Thử lại nha.",
  "profile.error.avatar_remove_failed": "Không xóa ảnh được. Thử lại nha.",
  "effects.title": "Hiệu ứng",
  "effects.soft": "Làm mịn",
  "effects.vignette": "Tối góc",
  "effects.face": "Che mặt",
  "effects.face_preview_only": "Che mặt (chỉ xem trước)",
  "effects.face_viewer_side": "Che mặt (phía người xem)",
  "effects.face_strength": "Mức độ che mặt",
  "effects.grade.off": "TẮT",
  "effects.grade.pop": "NỔI BẬT",
  "effects.grade.warm": "ẤM",
  "effects.grade.cool": "LẠNH",
  "effects.grade.bw": "TRẮNG ĐEN",
  "camera.off": "cam đang tắt",
  "camera.check": "check cam xíu",
  "camera.retry": "thử lại cam",
  "camera.ready": "cam đã sẵn sàng",
  "camera.idle.title": "Bật cam lên nào",
  "camera.idle.hint": "Bọn mình sẽ xin quyền truy cập trình duyệt khi bạn sẵn sàng.",
  "camera.idle.button": "Bật cam",
  "camera.status.idle": "Đang đợi bạn",
  "camera.status.off": "Cam đang tắt",
  "camera.status.loading": "Đang xin quyền mở cam...",
  "camera.status.denied": "Cấp quyền mở cam trên trình duyệt rồi thử lại nha.",
  "camera.status.error": "Lỗi xem trước cam. Thử lại nha.",
  "camera.status.unsupported": "Trình duyệt này không hỗ trợ mở cam.",
  "camera.status.insecure": "Mở cam cần có HTTPS hoặc localhost.",
  "camera.status.attach_failed": "Không thể bắt đầu xem trước cam. Thử lại nha.",
  "camera.guest_name_placeholder": "Tên khách",
  "camera.flip": "Đổi cam",
  "camera.save_name": "Lưu",
  "camera.edit_name": "Sửa tên",
  "mic.on": "Tắt mic",
  "mic.off": "Bật mic",
  "video.on": "Tắt cam",
  "video.off": "Bật cam",
  "chat.title": "chat",
  "chat.close": "Đóng chat",
  "chat.loading": "đang tải...",
  "chat.load_earlier": "tải tin cũ hơn",
  "chat.empty": "chưa có tin nhắn nào",
  "chat.send_error": "Chưa gửi được tin nhắn — thử lại nha.",
  "chat.input_placeholder": "nhập tin nhắn...",
  "room.host": "Host",
  "app.room_default_title": "Tạo phòng",
  "app.chat_connection_rejected": "Không kết nối được chat — thử F5 lại nha.",
  "app.copy_failed": "Không copy được link. Thử bôi đen rồi copy thủ công nha.",
  "app.chat_not_connected": "Chat chưa kết nối được. Đợi tí rồi thử lại nha.",
  "footer.terms": "Điều khoản & Điều kiện",
  "footer.copyright": "© 2026 Yano.AI"
}
